import { BlockWrapper } from "../Preview";
// import { Link } from "react-router-dom";
import React from "react";
import { generateCss, generateContent, generateLink, generateEvent, generateStyle } from "../../functions/sortableFunctions";
const LinkComponent = ({ block, ...props }: any) => {

    return (
        <React.Fragment>
            {
                React.createElement(
                    props.componentsPreview ? "span" : props.Link,
                    {
                        style: generateStyle({
                            props: {
                                ...props,
                                block
                            }
                        }),
                        className: generateCss({
                            props: {
                                ...props,
                                block: block
                            },
                        }),
                        id: block.id,
                        ...block.data,
                        // to: generateLink({
                        //     props: {
                        //         ...props,
                        //         block: block
                        //     },
                        //     link: block.data.to
                        // }),
                        [props.nextJs ? "href" : "to"]: generateLink({
                            props: {
                                ...props,
                                block: block
                            },
                            link: block.data.to
                        }),
                        onClick: block.events?.onClick ? async (e) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onClick"
                            });
                        } : null,
                        onDoubleClick: block.events?.onDoubleClick ? async (e) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onDoubleClick"
                            });
                        } : null,
                        onContextMenu: block.events?.onContextMenu ? async (e) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onContextMenu"
                            });
                        } : null,
                        onMouseOver: block.events?.onMouseOver ? async (e) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onMouseOver"
                            });
                        } : null,
                        onMouseLeave: block.events?.onMouseLeave ? async (e) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onMouseLeave"
                            });
                        } : null
                    },
                    block.children ?
                        block.children.map((value: any, index: any) => {
                            return <BlockWrapper
                                {...props}
                                key={index}
                                block={value}
                            />
                        })
                        :
                        generateContent({
                            props: {
                                ...props,
                                block: block
                            },
                        })
                )
            }
        </React.Fragment>
    )
}
export default LinkComponent;